import { c as _c } from "react/compiler-runtime";
import { List } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { SidebarEvents } from "@utils/track-event/track-event-list";
import { appStateSelector } from "@store/app/app-selector";
import { SidebarListItem } from "@components/sidebar/sidebar-list-item";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { SidebarSkeleton } from "@components/common/skeleton-loading/sidebar-skeleton";
/**
 * Map over the list of items and return them as a List component
 * Also handles selection and the selected item in the sidebar
 */
export function SidebarList(t0) {
  const $ = _c(21);
  const {
    isSidebarFullSize,
    sidebarItems
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isBetaTestingEnabled,
    isAlphaTestingEnabled
  } = useAppSelector(appStateSelector);
  const {
    hasFeatureCompanyLevel
  } = useHasUserValidFeatureCompanyLevel();
  const {
    fetchSelectedCompanyContext
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  let T0;
  let t1;
  let t2;
  if ($[0] !== fetchSelectedCompanyContext || $[1] !== hasFeatureCompanyLevel || $[2] !== isAlphaTestingEnabled || $[3] !== isBetaTestingEnabled || $[4] !== isSidebarFullSize || $[5] !== sidebarItems || $[6] !== trackEvent) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t3;
      if ($[10] !== hasFeatureCompanyLevel || $[11] !== isAlphaTestingEnabled || $[12] !== isBetaTestingEnabled) {
        t3 = sidebarItem => {
          if (sidebarItem.shouldShowOnlyInBeta && !isBetaTestingEnabled) {
            return false;
          }
          if (sidebarItem.shouldShowOnlyInAlpha && !isAlphaTestingEnabled) {
            return false;
          }
          return sidebarItem.requiredFeatureCompanyLevel && hasFeatureCompanyLevel({
            featureName: sidebarItem.requiredFeatureCompanyLevel
          });
        };
        $[10] = hasFeatureCompanyLevel;
        $[11] = isAlphaTestingEnabled;
        $[12] = isBetaTestingEnabled;
        $[13] = t3;
      } else {
        t3 = $[13];
      }
      const filteredSidebarItems = sidebarItems.filter(t3);
      if (fetchSelectedCompanyContext === "pending") {
        let t4;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <SidebarSkeleton />;
          $[14] = t4;
        } else {
          t4 = $[14];
        }
        t2 = t4;
        break bb0;
      }
      T0 = List;
      let t4;
      if ($[15] !== isSidebarFullSize || $[16] !== trackEvent) {
        t4 = sidebarItem_0 => <SidebarListItem key={sidebarItem_0.identity} isSidebarFullSize={isSidebarFullSize} sidebarItem={sidebarItem_0} onClick={() => trackEvent({
          name: SidebarEvents.openTab,
          props: {
            tab: sidebarItem_0.identity.toLowerCase()
          }
        })} />;
        $[15] = isSidebarFullSize;
        $[16] = trackEvent;
        $[17] = t4;
      } else {
        t4 = $[17];
      }
      t1 = filteredSidebarItems.map(t4);
    }
    $[0] = fetchSelectedCompanyContext;
    $[1] = hasFeatureCompanyLevel;
    $[2] = isAlphaTestingEnabled;
    $[3] = isBetaTestingEnabled;
    $[4] = isSidebarFullSize;
    $[5] = sidebarItems;
    $[6] = trackEvent;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
  } else {
    T0 = $[7];
    t1 = $[8];
    t2 = $[9];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[18] !== T0 || $[19] !== t1) {
    t3 = <T0>{t1}</T0>;
    $[18] = T0;
    $[19] = t1;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}